import React, {useState} from "react";
import {Columns, Heading, Modal, Section, Form} from "react-bulma-components";
import QuoteItem from "./QuoteItem";
import DepartmentPicker from "../../Job/DepartmentPicker";


export default function CreateDuplicateQuoteModal({open, setOpen, rental, onQuoteDuplicate}){

    return (
        <Modal
            show={open}
            onClose={() => {
                setOpen(false)}
            }
            closeOnBlur

        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Duplicate A Quote</Heading>
                        </Columns.Column>
                    </Columns>
                    {rental.quotes.filter(quote => quote.rental).map(quote => (
                        <QuoteItem
                            quote={quote}
                            onDuplicate={onQuoteDuplicate}
                        />
                    ))}
                </Section>
            </Modal.Content>
        </Modal>
    )
}